/**
 * Alle durchsuchbaren Inhalte (F-18), live - geladen nur, solange gesucht
 * wird. Der globale Bereichsfilter gilt bewusst nicht: die Suche soll alles
 * finden, auch was gerade ausgeblendet ist.
 */
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { suchIndex, type SuchEintrag } from '@/domain/suche';
import { today } from '@/lib/datetime';

export function useSuchIndex(aktiv: boolean): SuchEintrag[] | undefined {
  return useLiveQuery(async () => {
    if (!aktiv) return undefined;
    const [resources, thoughts, tasks, projects, goals, journal, weeklyReviews, monthlyReviews, focusGoals, books, events, listen, listenEintraege, trainingsplaene, planEinheiten, uebungen, trainingsprotokolle, lebensmittel, rezepte] = await Promise.all([
      db.resources.toArray(), db.thoughts.toArray(), db.tasks.toArray(), db.projects.toArray(), db.goals.toArray(),
      db.journal.toArray(), db.weeklyReviews.toArray(), db.monthlyReviews.toArray(), db.focusGoals.toArray(),
      db.books.toArray(), db.events.toArray(), db.listen.toArray(), db.listenEintraege.toArray(),
      db.trainingsplaene.toArray(), db.planEinheiten.toArray(), db.uebungen.toArray(), db.trainingsprotokolle.toArray(),
      db.lebensmittel.toArray(), db.rezepte.toArray(),
    ]);
    return suchIndex({ resources, thoughts, tasks, projects, goals, journal, weeklyReviews, monthlyReviews, focusGoals, books, events, listen, listenEintraege, trainingsplaene, planEinheiten, uebungen, trainingsprotokolle, lebensmittel, rezepte }, today());
  }, [aktiv]);
}
